<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar IMrecord">
            <h1 class="bar-title">聊天记录    <i class="el-icon-close close" @click.stop.prevent="hide"></i></h1>
        
            <div class="recordArea" v-if="detailList.length" v-infinite-scroll="getDetail" infinite-scroll-disabled="disabled">
                <div v-for="(item,index) in detailList" :key="index">
                    <div class="item customer clearfix" v-if="item.type===2">
                        <p class="tit"><span class="name">客户{{item.customer_nickname ? item.customer_nickname : item.customer_mobile}}</span><em>{{item.msg_time_stamp}}</em></p>
                        <div class="content cnt1" v-if="item.msg_body.MsgType=='TIMCustomElem' && item.msg_body.MsgContent.Data=='broker_welcome'">
                            <p class="txt">{{item.msg_body.MsgContent.Ext.content}}</p>
                        </div>
                        <div class="content cnt2" v-if="item.msg_body.MsgType=='TIMCustomElem' && item.msg_body.MsgContent.Data=='customer_house'">
                            <a :href="item.msg_body.MsgContent.Ext.url" target="_blank"><p class="txt">【楼盘卡】{{item.msg_body.MsgContent.Ext.title}}</p></a>
                        </div>
                        <div class="content cnt3" v-if="item.msg_body.MsgType=='TIMImageElem'">
                             <el-image 
                                style=" width:260px; height: 150px"  
                                :src='item.msg_body.MsgContent.ImageInfoArray[0].URL'
                                :preview-src-list="srcList">
                            </el-image>
                        </div>
                        <div class="content cnt4" v-if="item.msg_body.MsgType=='TIMCustomElem' && item.msg_body.MsgContent.Data=='authorize_analysis' || item.msg_body.MsgContent.Data=='authorize_service' ||  item.msg_body.MsgContent.Data=='authorize_report'     ">
                            <p class="txt">【授权卡】{{item.msg_body.MsgContent.Ext.status==0 ? '未知' : '已授权'}}</p>
                        </div>
                        <div class="content cnt5" v-if="item.msg_body.MsgType=='TIMTextElem'">
                             <p class="txt">{{item.msg_body.MsgContent.Text}}</p>
                        </div>

                    </div>
                    <div class="item agent clearfix" v-if="item.type===1">
                        <p class="tit"><span class="name">{{item.admin_nickname ? item.admin_nickname : item.admin_name}}</span><em>{{item.msg_time_stamp}}</em></p>
                        <div class="content cnt1" v-if="item.msg_body.MsgType=='TIMCustomElem' && item.msg_body.MsgContent.Data=='broker_welcome'">
                            <p class="txt">{{item.msg_body.MsgContent.Ext.content}}</p>
                        </div>
                        <div class="content cnt2" v-if="item.msg_body.MsgType=='TIMCustomElem' && item.msg_body.MsgContent.Data=='customer_house'">
                            <a :href="item.msg_body.MsgContent.Ext.url"  target="_blank"><p class="txt">【楼盘卡】{{item.msg_body.MsgContent.Ext.title}}</p></a>
                        </div>
                        <div class="content cnt3" v-if="item.msg_body.MsgType=='TIMImageElem'">
                             <el-image 
                                style=" width:260px; height: 150px"
                                :src='item.msg_body.MsgContent.ImageInfoArray[0].URL'
                                :preview-src-list="srcList">
                            </el-image>
                        </div>
                        <div class="content cnt4" v-if="item.msg_body.MsgType=='TIMCustomElem' && item.msg_body.MsgContent.Data=='authorize_analysis' || item.msg_body.MsgContent.Data=='authorize_service' ||  item.msg_body.MsgContent.Data=='authorize_report'     ">
                             <p class="txt">【授权卡】{{item.msg_body.MsgContent.Ext.status==0 ? '未知' : '已授权'}}</p>
                        </div>
                         <div class="content cnt5" v-if="item.msg_body.MsgType=='TIMTextElem'">
                             <p class="txt">{{item.msg_body.MsgContent.Text}}</p>
                        </div>
                    </div>
                </div>
                 <el-row style="height: 50px" v-if="loading"
                    v-loading="loading"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.3)"></el-row>
                <p class="nomore" v-if="noMore">没有更多了</p>
            </div>
        </div>
    </PopoverRight>
</template>

<script>
    import PopoverRight from '@/components/popoverRight/index'
    import {getImDetail} from '@/service/customer'
    import { parseTime } from '@/utils'


    export default {
        name: "add",
        components: {
            PopoverRight,
        },
        data () {
            return {
                info:null,
                detailList:[],
                loading: false,
                pages:1,
                currentPage:0,
                url:'',
                srcList:[]
            }
        },
        computed: {
            noMore () {
                return this.currentPage>=this.pages;
            },
            disabled () {
                return this.loading || this.noMore
            }

        },
        methods : {
            async open () {
                this.currentPage=0
                this.detailList=[];
                await this.getDetail()
                this.$refs.popoverMenu && this.$refs.popoverMenu.open();
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
            },
            getDetail(){
                this.loading = true;
                this.currentPage=this.currentPage+1
                let query={
                    admin_mobile:this.info.admin_mobile,
                    customer_account:this.info.customer_account,
                    site_id:this.info.city_id,
                    page:this.currentPage
                }
                getImDetail(query).then((data) => {
                    let list=data.data.data;
                    this.pages=Math.ceil(data.data.total/20)
                    this.currentPage=data.data.current_page
                    list.forEach(el=>{
                        el.msg_time_stamp=parseTime(el.msg_time_stamp)
                        if(el.msg_body.MsgContent.Data=='customer_house'){
                            el.msg_body.MsgContent.Ext.url=el.msg_body.MsgContent.Ext.content.pc_house_url
                        }
                        if(el.msg_body.MsgType=='TIMImageElem'){
                            this.srcList.push(el.msg_body.MsgContent.ImageInfoArray[0].URL)
                        }
                    })
                    this.detailList=this.detailList.concat(list)  
                    this.loading = false;
                })
      
            },

        },
    }
</script>

<style>


   .IMrecord .el-dialog__body{
        padding:0!important;
    }
    .IMrecord .popover-slider-bar .bar-title{
        position: fixed;
        width: 100%;
        border-bottom: 1px solid #ddd;
        background: #fff;
        padding: 20px;
        top: 0px;
        z-index: 9;
    }
    .clearfix:after {
        content: "";
        display: block;
        clear: both;
    }
    .IMrecord i.close{
        position: fixed;
        font-size: 34px;
        top: 16px;
        right: 30px;
    }
    .IMrecord .popover-dialog .el-dialog{
            background: #f9f9f9;
    }
    .recordArea{
        width:100%;
        padding-top:50px;
        box-sizing: border-box;
    }

    .recordArea .item{
        margin-bottom: 10px;
    }
    .recordArea .item p.tit{
        line-height:30px;
    }
     .recordArea .item p.tit .name{
         padding-right:20px;
     }
     .recordArea .item p.tit em{
         font-style: normal;
     }
    .recordArea .item .content{
        padding: 20px 0;
    }
    .recordArea .item p.txt{
        padding: 15px;
        line-height: 20px;
        background: #ddd;
    }
    .recordArea .item.agent p.tit{
        text-align: right;
    }
    .recordArea .item.agent .content{
        text-align: left;
        max-width: 80%;
        float: right;
    }
    .recordArea .item.customer .content{
        text-align: left;
        max-width: 80%;
        float: left;
    }
    .recordArea a{
        color:#333;
        text-decoration: none;
    }
    .recordArea .item.customer p.txt{
        background: #f5f5f5;
    }
    .nomore{
        text-align: center;
        font-size: 16px;
        color: #999;
    }
    .el-image-viewer__wrapper{
        z-index: 9999!important;
    }
    .el-image-viewer__close{
        right: 100px!important;
    }
    .el-icon-circle-close:before{
        color: #fff!important;
    }
</style>
